// extracted by mini-css-extract-plugin
module.exports = {"summary":"NutrientBalanceTable_summary_2jR76"};